import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import { authApi } from '@/api';
import { APP_CONSTANTS } from '@/constants';
import { StorageUtil } from '@/utils/storage/storageUtil';
import type { AuthState, UserProfile, LoginResponse } from '@/types/auth';

const initialState: AuthState = {
  user: StorageUtil.get<UserProfile>(APP_CONSTANTS.USER_KEY),
  token: StorageUtil.get<string>(APP_CONSTANTS.TOKEN_KEY),
  refreshToken: StorageUtil.get<string>(APP_CONSTANTS.REFRESH_TOKEN_KEY),
  isAuthenticated: !!StorageUtil.get<string>(APP_CONSTANTS.TOKEN_KEY),
  isLoading: false,
  error: null,
};

// Username/password login disabled - Microsoft SSO only
// export const loginThunk = createAsyncThunk<LoginResponse, LoginRequest>(
//   'auth/login',
//   async (credentials, { rejectWithValue }) => {
//     try {
//       const { data } = await authApi.login(credentials);
//       StorageUtil.set(APP_CONSTANTS.TOKEN_KEY, data.token);
//       StorageUtil.set(APP_CONSTANTS.REFRESH_TOKEN_KEY, data.refreshToken);
//       StorageUtil.set(APP_CONSTANTS.USER_KEY, data.employee);
//       return data;
//     } catch (error: any) {
//       return rejectWithValue(error.response?.data?.error || 'Login failed');
//     }
//   },
// );

export const fetchCurrentUser = createAsyncThunk<UserProfile>(
  'auth/fetchCurrentUser',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authApi.me();
      StorageUtil.set(APP_CONSTANTS.USER_KEY, data);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch user');
    }
  },
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      StorageUtil.remove(APP_CONSTANTS.TOKEN_KEY);
      StorageUtil.remove(APP_CONSTANTS.REFRESH_TOKEN_KEY);
      StorageUtil.remove(APP_CONSTANTS.USER_KEY);
    },
    setCredentials: (state, action: PayloadAction<LoginResponse>) => {
      state.user = action.payload.employee;
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
    },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(loginThunk.pending, (state) => { state.isLoading = true; state.error = null; })
      // .addCase(loginThunk.fulfilled, (state, action) => {
      //   state.isLoading = false;
      //   state.user = action.payload.employee;
      //   state.token = action.payload.token;
      //   state.refreshToken = action.payload.refreshToken;
      //   state.isAuthenticated = true;
      // })
      // .addCase(loginThunk.rejected, (state, action) => {
      //   state.isLoading = false;
      //   state.error = action.payload as string;
      // })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => { state.user = action.payload; })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.user = null; state.token = null; state.isAuthenticated = false;
      });
  },
});

export const { logout, setCredentials, clearError } = authSlice.actions;
export default authSlice.reducer;
